// Billing Subscription Modify
export const BILLING_SUBSCRIPTION_MODIFY_REQUEST = 'BILLING_SUBSCRIPTION_MODIFY_REQUEST';
export const BILLING_SUBSCRIPTION_MODIFY_DONE = 'BILLING_SUBSCRIPTION_MODIFY_DONE';
export const BILLING_SUBSCRIPTION_MODIFY_FAILED = 'BILLING_SUBSCRIPTION_MODIFY_FAILED';
export const BILLING_SUBSCRIPTION_MODIFY_RESET = 'BILLING_SUBSCRIPTION_MODIFY_RESET';
